export default function block_livetiming() {
  if ($('.felds-livetiming-block').length == 0) return;

  // Fetch the visibility status for the leaderboard block
  fetch('https://storage.googleapis.com/feld-supercross-automation/automation.json')
      .then(response => response.json())
      .then(data => {
          // Use the 'leaderboard' key to decide if the block should be shown

          
          if (data['leaderboard']) {
              $('.livetiming-results-wrapper').show();
              // Initiate the first call to refresh livetiming and set it to repeat
              refresh_livetiming();
          } else {
              $('.livetiming-results-wrapper').hide();
          }
      })
      .catch(error => console.error('Error fetching block visibility status:', error));

  function refresh_livetiming() {
      $.ajax({
          url: $('.felds-livetiming-block').data('url'),
          type: 'GET',
          success: function(res) {
              $('#livetiming-results').html($(res).find('#livetiming-results').html());
          }
      });

      // Continue to refresh the livetiming every 30 seconds if shown
      setTimeout(refresh_livetiming, 30000);
  }
}

